import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  Switch,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useLoaderData, useNavigate } from "react-router-dom";

import EditIcon from "@mui/icons-material/Edit";
import SyncIcon from "@mui/icons-material/Sync";

import { toast } from "react-toastify";
import DefaultApiService from "../../../../../infrastructure/api/default";
import useCheckPermission from "../../../../common/hooks/useCheckPermission";
import useGetPageInfo from "../../../../common/hooks/useGetPageInfo";
import DeleteConfirm from "../../../../components/shared/Dialog/DeleteConfirm";
import BreadcrumbsComponent from "../../../../components/shared/breadcrumbs";
import EnhancedTable from "../../../../components/shared/table";

const SupervisorInfoPage = () => {
  const pageInfo = useGetPageInfo();
  const hasEditPermission = useCheckPermission("edit");

  const dataList = useLoaderData("root");

  let navigate = useNavigate();
  const [deleteConfirm, setDeleteConfirm] = useState({
    open: false,
    data: {},
    cascadeDelete: false,
  });

  // بررسی اینکه آیا کاربر فعلی اطلاعاتی دارد یا نه
  const hasData = dataList && dataList.length > 0;
  const headCells = [
    {
      id: "updateOn",
      label: "تاریخ",
      type: "date",
    },

    {
      id: "fullName",
      label: "نام و نام خانوادگی",
    },

    {
      id: "companyName",
      label: "شرکت توزیع",
    },

    {
      id: "supervisorInfoStatus",
      label: "وضعیت ",
    },
    {
      id: "mobile",
      label: "همراه",
    },

    {
      id: "telephon",
      label: "تلفن",
    },
  ];

  const onEditClicked = (row) => {
    navigate(`${row.id}`);
  };

  const onCheckRequestClicked = (row) => {
    if (row.requestConfirm !== "NotChecked") {
      navigate(`Information?id=${row.id}`);
    } else {
      toast.warn("فقط امکان بررسی درخواست هایی که چک شده اند وجود دارد.");
    }
  };

  const onDeleteClicked = (row) => {
    setDeleteConfirm((old) => ({ ...old, open: true, data: row }));
  };

  const confirmedDelete = () => {
    return DefaultApiService.deleteOneApi("SLN/Contractors/Request", {
      id: deleteConfirm.data.id,
      cascadeDelete: deleteConfirm.cascadeDelete,
    });
  };

  const onFetchData = () => {
    navigate();
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={12}>
        <BreadcrumbsComponent />

        <DeleteConfirm
          message={`برای حذف "${deleteConfirm.data.feederName}" اطمینان دارید؟`}
          open={deleteConfirm.open}
          onClose={(loadAgain) => {
            setDeleteConfirm({
              open: false,
              data: {},
              cascadeDelete: false,
            });
            if (loadAgain) {
              navigate();
            }
          }}
          onSubmit={confirmedDelete}
        >
          <FormControlLabel
            name="cascadeDelete"
            checked={deleteConfirm.cascadeDelete}
            onChange={(event) => {
              setDeleteConfirm((old) => ({
                ...old,
                cascadeDelete: event.target.checked,
              }));
            }}
            control={<Switch color="danger" />}
            label="حذف از تمامی جاهایی که استفاده شده است"
          />
        </DeleteConfirm>
      </Grid>

      <Grid item xs={12} md={12}>
        <Card>
          <CardHeader
            title={pageInfo.title}
            action={
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "fit-content",
                }}
              >
                <Divider
                  orientation="vertical"
                  variant="middle"
                  flexItem
                  sx={{ mx: 1 }}
                />

                <IconButton
                  variant="text"
                  color="primary"
                  onClick={onFetchData}
                >
                  <SyncIcon />
                </IconButton>
              </Box>
            }
          />

          <CardContent>
            {!hasData ? (
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Alert severity="info">
                    <Typography variant="body1" gutterBottom>
                      اطلاعات شما هنوز ثبت نشده است.
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      لطفاً اطلاعات خود را تکمیل کنید تا بتوانید از امکانات سیستم استفاده نمایید.
                    </Typography>
                    <Box sx={{ mt: 2 }}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => navigate("create")}
                      >
                        ثبت اطلاعات
                      </Button>
                    </Box>
                  </Alert>
                </Grid>
              </Grid>
            ) : (
              <Grid container>
                <Grid item xs={12} md={12}>
                  <EnhancedTable
                    rowKey={"id"}
                    rows={dataList}
                    headCells={headCells}
                    pageSize={100}
                    actions={[
                      {
                        icon: hasEditPermission ? (
                          <EditIcon sx={{ width: "1rem", height: "1rem" }} />
                        ) : null,
                        onClick: onEditClicked,
                        color: "primary",
                      },
                    ]}
                  />
                </Grid>
              </Grid>
            )}
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default SupervisorInfoPage;
